// @ts-ignore
import { Axios } from 'core/httpServices';
import { QK_TOOLKIT } from './conts';

export const downloadToolkit = async () => {
	const { data } = await Axios.get('/toolkits/download');
	const downloadUrl = data?.downloadUrl;
	if (downloadUrl) {
		const link = document.createElement('a');
		link.download = 'AdaptationToolkit';
		link.href = downloadUrl;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
	return data;
};

export const getToolkitData = async () => {
	const { data } = await Axios.get(QK_TOOLKIT);
	return data.data;
};

export const updateToolkitData = async (params: any) => {
	const { data } = await Axios.put(QK_TOOLKIT, params);
	return data.data;
};
